import { Citrus, CloudSun, Moon, PartyPopper, Sun, Waves } from "lucide-react";
import { createContext } from "react";

export const Themes = {
  light: {name: 'Light', icon: <CloudSun size={18} />},
  dark: {name: 'Dark', icon: <Moon size={18} />},
  ocean: {name: 'Ocean', icon: <Waves size={18} />},
  glamour: {name: 'Glamour', icon: <PartyPopper size={18} />},
  solar: {name: 'Solar', icon: <Sun size={18} />},
  navy: {name: 'Navy & Orange', icon: <Citrus size={18} />},
} as const;

export type Theme = keyof typeof Themes; // 'light' | 'dark' | 'solar' | ...;

export interface ThemeContextType {
    theme: Theme;
    setTheme: (theme: Theme) => void;
    nextTheme: () => void;
    isDarkMode: boolean; 
}

export const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

